import { Session } from "../index.js";
import Game from "../game/index.js";
import { log } from "@tumbodash/browserPackages";
import store from "../store.js";

function debug() {
	log.sessionFx("(client/game/debug)");
	var slug = "tileTangle";
	var mountPoint = "game-root";
	const socket = store.socket!;

	socket.off("session:created");
	socket.on("session:created", sessionCreatedHandler);

	socket.off("debug:game:launched");
	socket.on("debug:game:launched", gameLaunchedHandler);

	var sessionId: string | null = null;

	function sessionCreatedHandler(payload: { data: { id: string } }) {
		log.sessionFx("(client/game/debug/sessionCreatedHandler)");

		sessionId = payload.data.id;
		Session.create({ sessionId });

		log.sessionEvent("Emit [debug:host:player:add]");
		socket.emit("debug:host:player:add", {
			data: {
				sessionId,
				player: {
					id: 'PV846bkeCQo3a0KZ',
					name: 'Cloud',
					color: 'blue',
					playerReady: true,
					clientReady: true
				}
			}
		});

		log.sessionEvent("Emit [debug:game:launch]");
		socket.emit("debug:game:launch", {
			data: { sessionId },
			meta: { emitCode: 482254 },
		});
	}

	function gameLaunchedHandler(payload: { data: { sessionId: string } }) {
		log.sessionFx("(client/game/debug/gameLaunchedHandler)");

		Game.init({
			sessionId: payload.data.sessionId,
			mountPoint: mountPoint,
		});
	}

	socket.emit("session:create", { data: { slug } });

	return () => {
		log.sessionFx("(client/game/debug) - Cleanup");
		socket.off("session:created", sessionCreatedHandler);
		Game.end(sessionId!);
	};
}

export default debug;
